
<template>
  <div class="footer-main-container">
    <accordion-group class="footer-main" :class="[schema.settings.textColor]">
      <div class="footer-main__column" v-for="block in filteredBlocks" :key="block.id" :class="{'footer-main__column--large footer-main__column--logo': block.type === 'logo_block'}">
        <accordion class="footer-main__menu-accordion" v-if="block.type === 'link_list_block' && $mq === 'mobile'" :heading="block.settings.menu.title" :titleClass="[schema.settings.headerColor, 'h7']" :iconClass="[schema.settings.headerColor.replace('color', 'fill')]" activeIcon="minus" inactiveIcon="plus" iconSize="14px">
          <div class="footer-main__menu-list" :class="[schema.settings.textColor]"><a class="footer-main__menu-link link--text body-sm-mobile" v-for="(link, index) in block.settings.menu.links" :key="index" :href="link.url">{{link.title}}</a></div>
        </accordion>
        <div class="footer-main__menu-content" v-else-if="block.type === 'link_list_block'">
          <div class="footer-main__menu-title body-lg" :class="[schema.settings.headerColor]">{{block.settings.menu.title}}</div>
          <div class="footer-main__menu-list" :class="[schema.settings.textColor]"><a class="footer-main__menu-link link link--text" v-for="(link, index) in block.settings.menu.links" :key="index" :href="link.url">{{link.title}}</a></div>
        </div>
        <div class="footer-main__logo-content" v-else><img class="footer-main__logo" v-if="block.settings.logo_png || block.settings.logo_svg" :src="block.settings.logo_svg ? block.settings.logo_svg : block.settings.logo_png" :alt="block.settings.logo_png_alt ? block.settings.logo_png_alt : ''"/>
          <div class="footer-main__title body-sm-mobile body-lg-tablet-up strong-bold" :class="[schema.settings.headerColor]">{{block.settings.title}}</div>
          <div class="footer-main__body body-sm-mobile body-md-tablet-up client-generated" v-html="block.settings.body" :class="[schema.settings.textColor]"></div>
        </div>
      </div>
    </accordion-group>
  </div>
</template>

<script>
import Accordion from '@/scripts/components/basic/Accordion.vue'
import AccordionGroup from '@/scripts/components/basic/AccordionGroup.vue'

export default {
  name: 'FooterMain',
  components: {
    Accordion,
    AccordionGroup
  },
  props: {
    schema: Object
  },
  methods: {},
  data () {
    return {}
  },
  computed: {
    filteredBlocks () {
      const filteredArr = []
      let columnTotal = 0
      this.schema.blocks.forEach((block) => {
        if (block.type === 'logo_block') {
          columnTotal += 2
        } else {
          columnTotal += 1
        }

        if (columnTotal > 6) {
          return
        }

        filteredArr.push(block)
      })

      return filteredArr
    }
  }
}
</script>

<style lang="scss">
  .footer-main-container {
    padding: 0;
    border-top: 1px solid;
    order: 1;

    @include tablet-up {
      padding: 40px 20px 44px;
      flex: 7.8;
    }
  }

  .footer-main {
    max-width: #{$container-max-width - 40px};
    margin: 0 auto;
    @include tablet-up {
      display: flex;
      justify-content: flex-start;
    }
    @include desktop-up {
      // justify-content: flex-end;
    }

    &__column {
      @include tablet-up {
        flex-basis: 33.3333%;
      }

      &:not(:last-child) {
        @include desktop-up {
          padding-right: 20px;
        }
      }

      @include mobile-tablet {
        border-bottom: 1px solid $color-off-black;
      }
    }

    &__column--large {
      @include desktop-up {
        flex-basis: 33.3333%;
      }
    }

    &__column--logo {
      @include tablet-only {
        display: none;
      }
    }

    &__menu-title {
      font-weight: bold;
      @include tablet-up {
        margin-bottom: 20px;
      }
    }

    &__menu-list {
      display: flex;
      padding-bottom: 16px;
      flex-direction: column;
      align-items: flex-start;

      @include tablet-up {
        padding-bottom: 0;
      }

      .footer-content--center & {
        @include mobile-only {
          align-items: center;
        }
      }
    }

    &__menu-link {
      color: inherit;
      margin-bottom: 16px;

      @include desktop-up {
        font-size: rem(16);
      }

      &:hover {
        color: $color-white;
        text-decoration: underline;
      }

      &:last-child {
        margin-bottom: 0;
      }

      @include mobile-only {
        text-decoration: none;
      }

      .footer-main-container.bg-brand-primary &:hover {
        color: $color-brand-secondary;
      }
    }

    &__logo-content {
      padding: 24px 0 16px;

      @include tablet-up {
        display: none;
        padding-top: 0;
        padding-bottom: 0;
      }
      @include desktop-up {
        display: block;
      }

      .footer-content--center & {
        @include mobile-only {
          text-align: center;
        }
      }
    }

    &__logo {
      display: block;
      max-width: 170px;
      margin-bottom: 16px;

      .footer-content--center & {
        @include mobile-only {
          margin: 0 auto 16px;
        }
      }
    }
  }
</style>
